<template>
  <div>
    <section class="content">
      <div class="col-md-12">
        <div class="portlet light">
          <div class="portlet-title">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Labels obtenus par le club</span>
                <span class="caption-helper"></span>
              </div>
            </div>
          </div>
          <div class="portlet-body">
            <div class="labels-obtenus">
              <div class="labels-logos">
                <div
                  class="label-column"
                  v-for="(prefix, label) in labelsMapping"
                  :key="label"
                >
                  <div class="label-logo" v-if="hasLabel(label)">
                    <img
                      :src="getLabelImageUrl(prefix, label)"
                      :alt="`Label ${label}`"
                    />
                  </div>
                  <div class="label-missing" v-else>
                    <i class="fa fa-times-circle"></i>
                    <span
                      >Au moins un critère labélisant est manquant<br />pour
                      obtenir le label {{ label }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="portlet light">
          <div class="portlet-title">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Critères labélisant du club</span>
                <span class="caption-helper"></span>
              </div>
            </div>
          </div>
          <div class="portlet-body">
            <div class="labels-container">
              <div class="label-item label-commun label-active">
                <div class="label-header">
                  <span class="label-nom">
                    Critères communs
                  </span>
                </div>
                <div class="label-conditions">
                  <div
                    class="label-condition"
                    :class="{
                      'critere-valide': isCritereValide(critere)
                    }"
                    v-for="critere in getCriteresLabelisants('Commun')"
                    :key="critere.id"
                  >
                    <span
                      class="critere-labelisant"
                      :class="{ 'critere-obtenu': isCritereValide(critere) }"
                    >
                      {{ critere.nom }}
                      <span
                        class="label-etoiles-requises"
                        v-if="critere.est_labelisant"
                      >
                        <span
                          v-for="n in 3"
                          :key="n"
                          class="etoile-requise"
                          :class="getEtoileRequiseClass(critere, n)"
                        >
                          <i
                            class="fa"
                            :class="getEtoileRequiseIconClass(critere, n)"
                          ></i>
                          <span class="etoile-numero">{{ n }}</span>
                        </span>
                      </span>
                    </span>
                    <div class="critere-details">
                      <div class="critere-detail">
                        <i class="fa fa-info-circle"></i>
                        <span>{{ critere.explication }}</span>
                      </div>
                      <div class="critere-detail">
                        <i class="fa fa-calendar"></i>
                        <span>Période : {{ critere.periode }}</span>
                      </div>
                      <div class="critere-detail">
                        <i class="fa fa-check-circle"></i>
                        <span>Évaluation : {{ critere.evaluation }}</span>
                      </div>
                      <div class="critere-detail">
                        <i
                          class="fa"
                          :class="
                            critere.est_labelisant
                              ? 'fa-star'
                              : 'fa-plus-circle'
                          "
                        ></i>
                        <span
                          class="critere-type"
                          :class="
                            critere.est_labelisant
                              ? 'type-labelisant'
                              : 'type-valorisant'
                          "
                        >
                          {{
                            critere.est_labelisant
                              ? "Critère labélisant"
                              : "Critère valorisant"
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="label-specifique-container ">
                <div
                  class="label-item label-specifique label-commun label-active"
                >
                  <div class="label-header">
                    <span class="label-nom">
                      Art Martial
                    </span>
                  </div>
                  <div class="label-conditions">
                    <div
                      class="label-condition"
                      :class="{
                        'critere-valide': isCritereValide(critere)
                      }"
                      v-for="critere in getCriteresLabelisants('Art Martial')"
                      :key="critere.id"
                    >
                      <span
                        class="critere-labelisant"
                        :class="{ 'critere-obtenu': isCritereValide(critere) }"
                      >
                        {{ critere.nom }}
                        <span
                          class="label-etoiles-requises"
                          v-if="critere.est_labelisant"
                        >
                          <span
                            v-for="n in 3"
                            :key="n"
                            class="etoile-requise"
                            :class="getEtoileRequiseClass(critere, n)"
                          >
                            <i
                              class="fa"
                              :class="getEtoileRequiseIconClass(critere, n)"
                            ></i>
                            <span class="etoile-numero">{{ n }}</span>
                          </span>
                        </span>
                      </span>
                      <div class="critere-details">
                        <div class="critere-detail">
                          <i class="fa fa-info-circle"></i>
                          <span>{{ critere.explication }}</span>
                        </div>
                        <div class="critere-detail">
                          <i class="fa fa-calendar"></i>
                          <span>Période : {{ critere.periode }}</span>
                        </div>
                        <div class="critere-detail">
                          <i class="fa fa-check-circle"></i>
                          <span>Évaluation : {{ critere.evaluation }}</span>
                        </div>
                        <div class="critere-detail">
                          <i
                            class="fa"
                            :class="
                              critere.est_labelisant
                                ? 'fa-star'
                                : 'fa-plus-circle'
                            "
                          ></i>
                          <span
                            class="critere-type"
                            :class="
                              critere.est_labelisant
                                ? 'type-labelisant'
                                : 'type-valorisant'
                            "
                          >
                            {{
                              critere.est_labelisant
                                ? "Critère labélisant"
                                : "Critère valorisant"
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="label-item label-specifique label-commun label-active"
                >
                  <div class="label-header">
                    <span class="label-nom">
                      Kyorugi
                    </span>
                  </div>
                  <div class="label-conditions">
                    <div
                      class="label-condition"
                      :class="{
                        'critere-valide': isCritereValide(critere)
                      }"
                      v-for="critere in getCriteresLabelisants('Kyorugi')"
                      :key="critere.id"
                    >
                      <span
                        class="critere-labelisant"
                        :class="{ 'critere-obtenu': isCritereValide(critere) }"
                      >
                        {{ critere.nom }}
                        <span
                          class="label-etoiles-requises"
                          v-if="critere.est_labelisant"
                        >
                          <span
                            v-for="n in 3"
                            :key="n"
                            class="etoile-requise"
                            :class="getEtoileRequiseClass(critere, n)"
                          >
                            <i
                              class="fa"
                              :class="getEtoileRequiseIconClass(critere, n)"
                            ></i>
                            <span class="etoile-numero">{{ n }}</span>
                          </span>
                        </span>
                      </span>
                      <div class="critere-details">
                        <div class="critere-detail">
                          <i class="fa fa-info-circle"></i>
                          <span>{{ critere.explication }}</span>
                        </div>
                        <div class="critere-detail">
                          <i class="fa fa-calendar"></i>
                          <span>Période : {{ critere.periode }}</span>
                        </div>
                        <div class="critere-detail">
                          <i class="fa fa-check-circle"></i>
                          <span>Évaluation : {{ critere.evaluation }}</span>
                        </div>
                        <div class="critere-detail">
                          <i
                            class="fa"
                            :class="
                              critere.est_labelisant
                                ? 'fa-star'
                                : 'fa-plus-circle'
                            "
                          ></i>
                          <span
                            class="critere-type"
                            :class="
                              critere.est_labelisant
                                ? 'type-labelisant'
                                : 'type-valorisant'
                            "
                          >
                            {{
                              critere.est_labelisant
                                ? "Critère labélisant"
                                : "Critère valorisant"
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="label-item label-specifique label-commun label-active"
                >
                  <div class="label-header">
                    <span class="label-nom">
                      Poomsae
                    </span>
                  </div>
                  <div class="label-conditions">
                    <div
                      class="label-condition"
                      :class="{
                        'critere-valide': isCritereValide(critere)
                      }"
                      v-for="critere in getCriteresLabelisants('Poomsae')"
                      :key="critere.id"
                    >
                      <span
                        class="critere-labelisant"
                        :class="{ 'critere-obtenu': isCritereValide(critere) }"
                      >
                        {{ critere.nom }}
                        <span
                          class="label-etoiles-requises"
                          v-if="critere.est_labelisant"
                        >
                          <span
                            v-for="n in 3"
                            :key="n"
                            class="etoile-requise"
                            :class="getEtoileRequiseClass(critere, n)"
                          >
                            <i
                              class="fa"
                              :class="getEtoileRequiseIconClass(critere, n)"
                            ></i>
                            <span class="etoile-numero">{{ n }}</span>
                          </span>
                        </span>
                      </span>
                      <div class="critere-details">
                        <div class="critere-detail">
                          <i class="fa fa-info-circle"></i>
                          <span>{{ critere.explication }}</span>
                        </div>
                        <div class="critere-detail">
                          <i class="fa fa-calendar"></i>
                          <span>Période : {{ critere.periode }}</span>
                        </div>
                        <div class="critere-detail">
                          <i class="fa fa-check-circle"></i>
                          <span>Évaluation : {{ critere.evaluation }}</span>
                        </div>
                        <div class="critere-detail">
                          <i
                            class="fa"
                            :class="
                              critere.est_labelisant
                                ? 'fa-star'
                                : 'fa-plus-circle'
                            "
                          ></i>
                          <span
                            class="critere-type"
                            :class="
                              critere.est_labelisant
                                ? 'type-labelisant'
                                : 'type-valorisant'
                            "
                          >
                            {{
                              critere.est_labelisant
                                ? "Critère labélisant"
                                : "Critère valorisant"
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      criteres: {},
      labelsMapping: {
        "Art Martial": "wam",
        Kyorugi: "wk",
        Poomsae: "wp"
      }
    };
  },
  methods: {
    ...mapActions({
      setLoading: "setLoading"
    }),
    getCriteresLabelisants(categorie) {
      return this.criteresDisponibles.filter(c => c.label === categorie);
    },
    isCritereValide(critere) {
      // Vérifier si le critère est directement validé
      const critereClub = this.criteresClub.find(
        c => c.critere_id === critere.id
      );
      if (critereClub) {
        const dateFin = new Date(
          critereClub.date_fin
            .split("/")
            .reverse()
            .join("-")
        );
        const aujourdhui = new Date();
        if (dateFin >= aujourdhui) return true;
      }

      // Si le critère a poids_plus_haut_compte_pour_total à 1
      if (critere.poids_plus_haut_compte_pour_total === 1) {
        // Trouver tous les critères de la même catégorie avec un poids plus élevé
        const criteresPlusEleves = this.criteresDisponibles.filter(
          c =>
            c.categorie === critere.categorie &&
            c.sous_categorie === critere.sous_categorie &&
            c.poids > critere.poids
        );

        // Vérifier si l'un de ces critères plus élevés est validé
        return criteresPlusEleves.some(criterePlusEleve => {
          const critereClubPlusEleve = this.criteresClub.find(
            c => c.critere_id === criterePlusEleve.id
          );
          if (critereClubPlusEleve) {
            const dateFin = new Date(
              critereClubPlusEleve.date_fin
                .split("/")
                .reverse()
                .join("-")
            );
            const aujourdhui = new Date();
            return dateFin >= aujourdhui;
          }
          return false;
        });
      }

      return false;
    },
    getHighestLabelLevel(labelName) {
      const labels = this.labelsClub.filter(l => l.label === labelName);
      if (labels.length === 0) return null;
      return Math.max(...labels.map(l => l.niveau));
    },
    hasLabel(categorie) {
      return this.getHighestLabelLevel(categorie) !== null;
    },
    getLabelImageUrl(prefix, label) {
      const niveau = this.getHighestLabelLevel(label);
      return `https://www.abft.be/wp-content/uploads/2025/05/${prefix}${niveau}.jpg`;
    },
    getEtoileRequiseClass(critere, numero) {
      const etoileRequise = critere[`labelisant_${numero}_etoile`] === 1;
      return {
        "etoile-active": etoileRequise,
        "etoile-inactive": !etoileRequise
      };
    },
    getEtoileRequiseIconClass(critere, numero) {
      const etoileRequise = critere[`labelisant_${numero}_etoile`] === 1;
      return etoileRequise ? "fa-star" : "fa-star-o";
    }
  },
  computed: {
    ...mapGetters({
      getClub: "getClub"
    }),
    labelsClub() {
      return (this.getClub && this.getClub.labelsClub) || [];
    },
    labelsDisponibles() {
      return (this.getClub && this.getClub.labelsDisponibles) || [];
    },
    criteresClub() {
      return (this.getClub && this.getClub.criteresClub) || [];
    },
    criteresDisponibles() {
      return (this.getClub && this.getClub.criteresDisponibles) || [];
    }
  }
};
</script>

<style scoped>
.labels-section {
  padding: 20px;
}

.categorie-title {
  margin-bottom: 20px;
  font-weight: bold;
}

.labels-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.label-item {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 15px;
  background-color: #fff;
}

.label-header {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.label-nom {
  font-weight: bold;
  font-size: 1.1em;
}

.label-conditions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.label-condition {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
  opacity: 0.6;
}

.label-condition.critere-valide {
  background-color: rgba(46, 204, 113, 0.1);
  opacity: 1;
}

.critere-labelisant {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9em;
  font-weight: 500;
}

.label-etoiles-requises {
  display: flex;
  gap: 5px;
  margin-left: 10px;
}

.etoile-requise {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 5px;
  border-radius: 3px;
}

.etoile-active {
  background-color: #f8f9fa;
}

.etoile-active i {
  color: #f1c40f;
}

.etoile-inactive i {
  color: #bdc3c7;
}

.fa-check-circle {
  color: #2ecc71 !important;
}

.fa-times-circle {
  color: #e74c3c !important;
}

.etoile-numero {
  font-size: 0.8em;
  color: #666;
  margin-left: 2px;
}

.label-commun {
  border-left: 4px solid #3498db;
}

.label-art-martial {
  border-left: 4px solid #2ecc71;
}

.label-kyorugi {
  border-left: 4px solid #e74c3c;
}

.label-poomsae {
  border-left: 4px solid #f1c40f;
}

.label-active {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.text-success {
  color: #2ecc71;
}

.text-danger {
  color: #e74c3c;
}

.label-specifique-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.critere-details {
  margin-top: 8px;
  padding-left: 25px;
  font-size: 0.8em;
  color: #666;
  width: 100%;
  opacity: 0.8;
}

.label-condition.critere-valide .critere-details {
  opacity: 1;
}

.critere-detail {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 4px;
  line-height: 1.3;
}

.critere-detail i {
  margin-top: 2px;
  color: #3498db;
  font-size: 0.9em;
}

.critere-detail span {
  flex: 1;
}

.labels-obtenus {
  /* padding: 30px; */
  /* background-color: #f8f9fa; */
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.labels-logos {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: nowrap;
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.label-column {
  flex: 1;
  width: 33.33%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.label-logo {
  width: 250px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
}

.label-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.label-missing {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #95a5a6;
  padding: 20px;
  text-align: center;
}

.label-missing i {
  font-size: 2em;
  color: #e74c3c;
}

.label-missing span {
  font-size: 1.1em;
  font-weight: 500;
}

.portlet {
  margin-bottom: 25px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.portlet:last-child {
  margin-bottom: 0;
}

.portlet-title {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.portlet-body {
  padding: 20px;
}

.critere-type {
  font-weight: 500;
}

.type-labelisant {
  color: #2ecc71;
}

.type-valorisant {
  color: #3498db;
}

.fa-star {
  color: #f1c40f;
}

.fa-plus-circle {
  color: #3498db;
}

.critere-obtenu {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/Club/ClubLabelisation.vue